var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
// require('bootstrap');

// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');
// require('bootstrap-material-design');

require('jquery-sticky');
// require('magnific-popup');

require('owl.carousel');
require('jquery-countdown');



// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

//   $(document).ready(function(){
//     $("#sticker").sticky({height:auto});
//   });


  $('.owl-speakers').owlCarousel({
        loop:false,
        margin:10,
        nav:false,
        dots:false,
        autoplay:false,
        autoWidth:true,
        // responsive:{
        //     0:{
        //         items:1
        //     },
        //     476:{
        //         items:2
        //     },
        //     1000:{
        //         items:3
        //     }
        // }
        });



  $('.owl-banners').owlCarousel({
        loop:true,
        margin:10,
        nav:false,
        dots:false,
        autoplay:false,
        responsive:{
            0:{
                items:1
            },
            480:{
                items:2,
            },
            768:{
                margin:96,
                items:2
            },
        }
        });


    //   setTimeout(function(){
    //     $('.inner-img-tag').fadeIn('slow');
    //   },500);

      //countdown yyyy/MM/DD
      $('#clock').countdown('2024/08/1', function(event) {
        $(this).html(event.strftime(''
        + '<table style="margin: 0px auto;"><tr><th class="px-2" style="font-size: 25px;font-weight: 300">%D</th><th class="px-2" style="font-size: 25px;font-weight: 300">%H</th><th class="px-2" style="font-size: 25px;font-weight: 300">%M</th><th class="px-2" style="font-size: 25px;font-weight: 300">%S</th></tr>'
        + '<tr><td class="px-2" style="font-size: 12px;">DAYS</td><td class="px-2" style="font-size: 12px;">HRS</td><td class="px-2" style="font-size: 12px;">MINS</td><td class="px-2" style="font-size: 12px;">SEC</td></tr></table>'
      ));
      });
      $('#clock1').countdown('2024/08/1', function(event) {
        $(this).html(event.strftime(''
        + '<table style="margin: 0px auto;font-size: 14px;font-weight: 300"><tr><th class="px-2">%D</th><th class="px-2">%H</th><th class="px-2">%M</th><th class="px-2">%S</th></tr>'
        + '<tr><td class="px-2">DAYS</td><td class="px-2">HRS</td><td class="px-2">MINS</td><td class="px-2">SEC</td></tr></table>'
      ));
      });

    $('#btn-menu').click(function() {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
    });

    $(window).on('resize load', function() {

        if ($(window).width() < 992) {
            $('.owl-mob').owlCarousel({
                loop: true,
                margin: 0,
                nav: false,
                dots: true,
                autoplay:true,
                smartSpeed:500,
                responsive: {
                    0: {
                        items: 1,
                        margin:0,
                    },
                    576: {
                        items: 2,
                        dots: true,
                    },
                    768: {
                        items: 3,
                        dots: true,
                    }
                }
            })
        } else {
            $('.owl-mob').owlCarousel('destroy');
        }
    });


    $('.page-scroll').bind('click', function (event) {
        var $anchor = $(this);

        $('html, body').stop().animate({
            scrollTop: $($anchor.attr('href')).offset().top - 55
        }, 750, 'easeInOutExpo');

        event.preventDefault();
    });

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }


});


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // Infinite Ajax Scroll
}
